import apis from ".";

export const emailResetPass = async (email) => {
  try {
    const response = await apis.post("/forgot-password", {
      emailOrPhone: email,
    });
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const resetPassVerify = async (token) => {
  try {
    const response = await apis.post("/forgot-password/verify", {
      Token: token,
    });
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const resetPass = async (newPassValue, confirmPassValue, token) => {
  try {
    const response = await apis.post("/reset-password", {
      Password: newPassValue,
      ConfirmPassword: confirmPassValue,
      Token: token,
    });
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
